// Hierarchy Levels
export const CreatePlan = {
  __plan_levels: ["l0_name", "l1_name", "l2_name", "l3_name", "l4_name"],
  __store_levels: ["channel", "region", "store_group"],
  __Application_level: "application",
  __Hierarchy_level: "hierarchy"
};
